import { render } from "./list-plt-virtual-scroll.vue?vue&type=template&id=3f36e9ce"
import script from "./list-plt-virtual-scroll.vue?vue&type=script&lang=js"
export * from "./list-plt-virtual-scroll.vue?vue&type=script&lang=js"

import "./list-plt-virtual-scroll.vue?vue&type=style&index=0&id=3f36e9ce&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__